import { LanguagesList } from '../LiveCamWidgetConsts';
import { v4 as uuidv4 } from 'uuid';
import 'materialize-css';
import { Select } from 'react-materialize';
import { InputText } from '../../../components/reusables';
import { FormattedMessage } from 'react-intl';
import messages from '../../../i18n/base-en';
const { LiveCamWidgetPage } = messages;

const TypeSettings = ({ language, expireDays, isWidgetChatHead, canHideChatHead }) => (
  <div className="settings-group" id="settings-section">
    <h2 className="primary-color">Settings</h2>
    {isWidgetChatHead ? (
      <div className="select-field language">
        <Select
          id="widget-categories"
          label={LiveCamWidgetPage.typeSettings.settingsSection.chatTextLanguage.text.defaultMessage}
          onChange={language.onChange}
          value={language.value}
        >
          {LanguagesList.map((language) => (
            <option key={uuidv4()} value={language.value}>
              {language.text}
            </option>
          ))}
        </Select>
      </div>
    ) : null}
    {!isWidgetChatHead || canHideChatHead ? (
      <div className="delay">
        <InputText
          field={expireDays}
          id="delay"
          label={LiveCamWidgetPage.typeSettings.settingsSection.expireDays.label}
          labelClasses="active"
          type="number"
        />

        <span className="unit-label">
          <FormattedMessage {...LiveCamWidgetPage.typeSettings.settingsSection.minutes.text} />
        </span>
      </div>
    ) : null}
  </div>
);

export default TypeSettings;
